package io.horion.cv.api.datasource.cv
enum class Model(name: String) {
    SIMPLE("SIMPLE"),
    CV2("CV2"),
    CV3("CV3"),
    CV5("CV5"),
    CV6("CV6"),
    CV7("CV7"),
    CAMEROON("CAMEROON"),
    CANADA("CANADA"),
    FRANCE("FRANCE"),
}